import React, { useEffect, useState } from 'react'
import Header from '../../layout/Header';
import { Loader } from '../../loader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OTPInput from 'react-otp-input';
import Wrongotp from "../../../assets/images/wrongotp.png";
import ReactGA from 'react-ga4';
import { fetchAPI } from '../../service/Encrtyption';
import { genuityCheckData, login } from "../../auth/redux/store";
import CustomModal from '../../modal';
import Packet from "../../../assets/images/packet.jpg";
import Check from "../../../assets/images/check.png";
import Genuine_corteva_product from "../../../assets/images/genuine_corteva_product.png";
import Not_Genuine from "../../../assets/images/not_genuine.png";
import ProductId from "../../../assets/images/productId.png";
import { Button } from 'react-bootstrap';
import {
  getScanLimitNotice,
  isScanLimitReached,
} from '../../../utils/genuityCheck';
import { setOtpVerified } from '../../../utils/otpSession';
import {
  OTP_VERIFY_INPUT_STYLES,
  OTP_INPUT_CONTAINER_STYLE,
  createOtpRenderInput,
} from '../../auth/otpVerifyInput';
import {
  parseUfromFcParam,
  resolveFcCustomerId,
  resolveFcMobileNumber,
} from '../../../utils/fcDeepLink';
import { convertMediaUrls } from '../../../utils/authenticatedImages';

const VerifyOtp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const currentLanguage = lang;
  const [scanedDataObject, setScanedDataObject] = useState({});
  const [otpDigits, setOtpDigits] = useState("");
  const productName = sessionStorage.getItem('productName');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const mobileNumber = sessionStorage.getItem('mbn');
  const [productID, setProductID] = useState("");
  const [apiProductName, setApiProductName] = useState("");
  const [stepOneClear, setStepOneClear] = useState(false);
  const [stepTwoClear, setStepTwoClear] = useState(false);
  const [secondaryRewardMsg, setSecondaryRewardMsg] = useState("");
  const [scanResponseData, setScanResponseData] = useState({});
  const [GenunityCheckModal, setGenunityCheckModal] = useState(false);
  const [ErrorModalGenunity, setErrorModalGenunity] = useState(false);
  const [navbarWhite, setNavbarWhite] = useState(false);
  const [otpValid, setOtpValid] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [resend, setResend] = useState(false);
  const [OTPInvalid, setOTPInvalid] = useState(false);
  const [scanErrorResponseData, setscanErrorResponseData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [OTPSuccess, setOTPSuccess] = useState(false);
  const surl = useSelector((state) => state?.scandataUrl);
  const loginData = useSelector((state) => state?.user);

  useEffect(() => {
    if (surl && Object.keys(surl).length > 0) {
      const result =
        typeof surl === "string" ? JSON.parse(surl) : surl;
      setScanedDataObject(result);
    }
  }, [surl]);

  useEffect(() => {
    const fromFc = sessionStorage.getItem("ufromFcPayload");
    if (!fromFc) return;
    if (loginData?.statusCode === "200" || OTPSuccess) return;

    const fcData = parseUfromFcParam(fromFc);
    const mbn =
      resolveFcMobileNumber(fcData) ||
      scanedDataObject?.mobileNumber ||
      sessionStorage.getItem("mbn");
    if (!mbn) return;

    const customerId =
      resolveFcCustomerId(fcData) ||
      scanedDataObject?.customerId ||
      sessionStorage.getItem("cid") ||
      "";

    sessionStorage.setItem("mbn", mbn);
    if (customerId) {
      sessionStorage.setItem("cid", customerId);
    }

    setOTPSuccess(true);
    dispatch(
      login({
        statusCode: "200",
        mobileNumber: mbn,
        customerId,
      })
    );
  }, [
    dispatch,
    loginData?.statusCode,
    OTPSuccess,
    scanedDataObject?.mobileNumber,
    scanedDataObject?.customerId,
  ]);


  const [loginSubmit, setLoginSubmit] = useState({
    deviceType: "WEB",
    mobileNumber: "",
    otp: "",
    destinationURL: "/customer/saveGenuinityCheckDetails_V2_acviss",
    deviceId: "",
    otpVerified: false,
    countryId: 5,
    appLangCode: currentLanguage
  });

  const handleOTPInputChange = (otpDigits) => {
    // debugger;
    setLoginSubmit((prevFormData) => ({
      ...prevFormData,
      ...scanedDataObject,
      otp: otpDigits,
      mobileNumber:
        scanedDataObject?.mobileNumber ||
        loginData?.mobileNumber ||
        mobileNumber,
      customerId:
        scanedDataObject?.customerId ||
        loginData?.customerId ||
        sessionStorage.getItem("cid") ||
        "",
      moduleType: productName
    }));

    console.log(loginSubmit);
    setOtpDigits(otpDigits);
  };

  function OTPValidate(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  const handleOtpFormSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };

  const [formData, setFormData] = useState({
    mobileNumber: mobileNumber,
    deviceId: "",
    programName: "gallant",
    userAcceptanceKey: "0",
    destinationURL: "/customer/sendOTPForMicrosite",
  });

  // RESEND OTP / RETRY FUNCTION
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    ReactGA.event({
      category: 'Btn',
      label: 'Resend OTP Button',
      action: 'Resend OTP Clicked'
    });

    setLoading(true);
    // RESET STATES
    setOTPInvalid(false);
    setTimerCompleted(false);
    setOTPSuccess(false);
    setErrorMsg("");
    setOtpDigits("");
    setSeconds(30);
    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          appLangCode: currentLanguage
        }
      );
      const jsonReposneData = JSON.parse(responseData);
      setOtpVerified(false);
      dispatch(login(jsonReposneData));
      console.log(jsonReposneData);
      if (jsonReposneData.statusCode === "200") {
        sessionStorage.setItem('mbn', jsonReposneData.mobileNumber);
        sessionStorage.setItem('cid', jsonReposneData.customerId);
        // SHOW OTP SCREEN AGAIN
        setOTPSuccess(true);
        // START TIMER AGAIN
        setSeconds(30);
        setTimerCompleted(false);
      } else {
        setErrorMsg(jsonReposneData.message);
      }

    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  ///login code for submititing the details
  const onLogin = async () => {
    // debugger; 
    setLoading(true);

    ReactGA.event({
      category: 'Btn',
      label: 'OTP Submitted',
      action: 'Verify OTP Clicked'
    });

    try {
      const { otp } = loginSubmit; // Assuming 'otp' is the key for the OTP value
      const trimmedOtp = otp.trim();
      if (!otp || otp.trim() === "" || trimmedOtp.length !== 4) {
        // Check if OTP is empty or only whitespace
        setErrorMsg(t("otpError")); // Set an error message for empty OTP
        setLoading(false);
        return;
      }

      if (!surl) {
        setErrorMsg(t("sessionExperied"));
        setLoading(false);
        return;
      }

      const submitPayload = {
        ...loginSubmit,
        ...scanedDataObject,
        otp: trimmedOtp,
        mobileNumber:
          scanedDataObject?.mobileNumber ||
          loginData?.mobileNumber ||
          sessionStorage.getItem("mbn") ||
          "",
        customerId:
          scanedDataObject?.customerId ||
          loginData?.customerId ||
          sessionStorage.getItem("cid") ||
          "",
        directScanConsentAgreed: true
      };

      setLoading(true);

      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL_SCAN,
        submitPayload,
        {
          mobileNumber: submitPayload.mobileNumber,
          customerId: submitPayload.customerId,
          userAuthorizationToken: "",
          deviceid: "WEB",
          appLangCode: currentLanguage

        }
      );
      console.log(JSON.stringify(submitPayload) + "otp submit data");
      setLoading(false);
      //  alert(JSON.stringify(loginSubmit));
      const jsonReposneData = JSON.parse(responseData);
      const mediaData = await convertMediaUrls(jsonReposneData);
      setOtpValid(true);
      console.log(jsonReposneData, "otp response data");
      console.log(mediaData, "otp response mediaData data"); 
      if (
        jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode === "100") {
        console.log("jsonReposneData" + JSON.stringify(jsonReposneData));
        console.log(JSON.stringify(jsonReposneData.strongArmObject) + "strongArmObject");
        // const strongArmObject = jsonReposneData.strongArmObject;
        let resProductID = null;
        if (jsonReposneData.strongArmObject?.textTwo) {
          resProductID = jsonReposneData.strongArmObject.textTwo;
        }

        // const resProductID = jsonReposneData.prodSerialNumber;
        // const resProductID = strongArmObject.textTwo;
        const resProductName = jsonReposneData.productName;
        const resProfileUpdate = jsonReposneData.profileUpdate;
        const resShareProductInfo = jsonReposneData.shareProductInfo;
        // alert(resProfileUpdate + "profileUpdate" + resShareProductInfo + "resShareProductInfo");
        setProductID(resProductID);
        setApiProductName(resProductName);
        setStepOneClear(resProfileUpdate);
        setStepTwoClear(resShareProductInfo);
        const apiSecondaryRewardMsg = jsonReposneData.secondaryRewardMsg;
        setSecondaryRewardMsg(apiSecondaryRewardMsg);
        setScanResponseData(mediaData);
        dispatch(genuityCheckData(mediaData));
        setOtpVerified(true);

        if (jsonReposneData.isSpinDone === true && jsonReposneData.isAlreadyScannedProduct) {
          setErrorModalGenunity(true);
          return;
        }

        if (jsonReposneData.isAlreadyScannedProduct) {
          setErrorModalGenunity(true);
          return;
        }

        // if (jsonReposneData.isSpinDone === true && jsonReposneData.isAlreadyScannedProduct) {
        //   setErrorModalGenunity(true);
        //   return;
        // }

        if (!jsonReposneData.gallantProfileUpdate || jsonReposneData.gallantProfileUpdate == 0 || jsonReposneData.gallantProfileUpdate === null || jsonReposneData.gallantProfileUpdate === undefined) {
          navigate(`/${currentLanguage}/register`);
        } else {
          setGenunityCheckModal(true);
          setNavbarWhite(true);
          // setOtpValid(true);
          setShowTimer(false);
        }
      } else if (jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode != "100") {
        //debugger;
        setLoading(false);
        setScanResponseData(mediaData);
        setErrorModalGenunity(true);
        setNavbarWhite(true);
      } else {
        if (jsonReposneData?.statusCode === "123" || jsonReposneData?.statusCode === "122") {
          setOTPInvalid(true);
          setDisableBtn(true);
          setOtpDigits("");
          setOtpValid(false);
          setOtpVerified(false);
          setErrorMsg(jsonReposneData?.message || t("invalid_OTP"));
          setShowTimer(false);
          setResend(true);
        } else {
          setOtpValid(false);
          setOtpVerified(false);
          setErrorMsg(jsonReposneData?.message || t("invalid_OTP"));
        }
      }
    } catch (error) {
      //  debugger;
      setErrorMsg(error.message || t("Something_went_wrong"));
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderInput = createOtpRenderInput({
    getCurrentOtp: () => loginSubmit.otp || otpDigits,
    onEnter: onLogin,
    onKeyPressValidate: OTPValidate,
  });

  const [seconds, setSeconds] = useState(30);
  const [timerCompleted, setTimerCompleted] = useState(false);


  // TIMER
  // useEffect(() => {
  //   if (OTPInvalid) return;
  //   if (timerCompleted) return;
  //   if (seconds > 0) {
  //     const timer = setTimeout(() => {
  //       setSeconds((prev) => prev - 1);
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   } else { 
  //     setTimerCompleted(true); 
  //   }

  // }, [seconds, OTPInvalid, timerCompleted]);

  useEffect(() => {
    if (loading) return;          // Stop timer while API is loading
    if (OTPInvalid) return;
    if (timerCompleted) return;

    if (seconds > 0) {
      const timer = setTimeout(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setTimerCompleted(true);
    }
  }, [seconds, OTPInvalid, timerCompleted, loading]);


  // const scanLimitReached = isScanLimitReached(scanResponseData);

  const scanLimitReached = scanResponseData?.maxAcresReached;


  const scanLimitNotice =
    getScanLimitNotice(scanResponseData) || scanResponseData.uq_message || t("genuityCheck.scanLimitFallback");

  const handleGenuityScanMore = () => {
    ReactGA.event({
      label: "Btn",
      category: "User Scan More",
      action: "Clicked the Scan More Button",
    });
    setGenunityCheckModal(false);
    navigate(`/${lang}/scanProduct`);
  };

  const handleGenuityProceedCashback = () => {
    if (scanLimitReached) return;
    ReactGA.event({
      category: "Btn",
      label: "User Proceed",
      action: "Clicked the Proceed Button",
    });
    setGenunityCheckModal(false);

    if (scanResponseData?.isGiftClaimed) {
      navigate(`/${lang}/giftClaim`);
      return;
    }

    if (scanResponseData?.isSpinDone) {
      navigate(`/${lang}/spinNotApplicable`);
    } else {
      navigate(`/${lang}/spinwheel`);
    }

    // navigate(`/${lang}/rewardjourney`);
  };

  return (
    <>
      <style>{OTP_VERIFY_INPUT_STYLES}</style>
      <Header hideHomeIcon={!otpValid} />
      <div className="main px-2 mt-3">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card px-0 border-0">

            <div className="card-body px-0 pb-2 pt-0 pb-2">
              {/* OTP SCREEN */}
              {(loginData.statusCode === "200" || OTPSuccess) &&
                !OTPInvalid &&
                !timerCompleted &&
                !errorMsg && (
                  <div>
                    <h5 className="card-title font-bold text-center mb-3">
                      {t("enterOTP")}
                    </h5>

                    <p className="card-text text-center mb-3">
                      {t('otpSentMsg')}
                    </p>

                    <form onSubmit={handleOtpFormSubmit}>
                      <div className="form-group mt-3" id="opt_input">

                        <OTPInput
                          onChange={handleOTPInputChange}
                          value={otpDigits}
                          numInputs={4}
                          containerStyle={OTP_INPUT_CONTAINER_STYLE}
                          renderInput={renderInput}
                        />

                      </div>

                      <div className='text-center resendOtpSection'>

                        <div>
                          OTP{" "}
                          <span className="timerText">
                            00:{seconds.toString().padStart(2, "0")}
                          </span>{" "}
                          {t("resendOTPText")}
                        </div>

                      </div>

                      <button
                        type="submit"
                        className="btn submitBtn text-center btn-secondary py-2 center-textbtn mt-3 my-2 text-white otpSubmitBtn btnshadow"
                        style={{ marginLeft: "3%" }}
                        id="submitBtn"
                        disabled={otpDigits.length !== 4 || loading}
                      >
                        {t("OTPsubmit")}
                      </button>
                    </form>

                  </div>
                )}

              {/* OTP INVALID */}
              {OTPInvalid && !timerCompleted && (

                <div className='optErrorSec'>

                  <div className='text-center'>

                    <img
                      src={Wrongotp}
                      alt="Wrong OTP"
                      style={{
                        display: "block",
                        margin: "0 auto 20px",
                        width: "80px"
                      }}
                    />

                    <h5 className="card-title font-bold text-center mb-1 mt-4">
                      {t("invalid_OTP")}
                    </h5>

                    <p>
                      {t('enterTheCorrectOTP')}
                    </p>

                  </div>

                  <button
                    onClick={() => {
                      setOTPSuccess(true);
                      setOTPInvalid(false);
                      setErrorMsg("");
                      setTimerCompleted(false);
                    }}
                    className="btn submitBtn text-center btn-secondary py-2 center-textbtn mt-3 my-2 text-white otpSubmitBtn otpErrorBtn btnshadow"
                    id="submitBtn"
                  >
                    {t('tryagain')}
                  </button>

                </div>
              )}

              {/* TIMER COMPLETED */}
              {timerCompleted && !OTPInvalid && (

                <div className='optErrorSec'>

                  <div className='text-center'>

                    <h5 className="card-title font-bold text-center mb-1 mt-4">
                      {t("didn'treceiveOTP")}
                    </h5>

                    <p>
                      {t('sendingtoyournumber')}
                    </p>

                  </div>

                  <button
                    onClick={handleSubmit}
                    className="btn submitBtn text-center btn-secondary py-2 center-textbtn mt-3 my-2 text-white otpSubmitBtn btnshadow"
                    id="submitBtn">
                    {t('ResendOTP')}
                  </button>

                </div>
              )}

              {/* API ERROR */}
              {errorMsg &&
                !OTPInvalid &&
                !timerCompleted && (
                  <div className='optErrorSec'>
                    <div className='text-center'>
                      <img
                        src={Wrongotp}
                        alt="Wrong OTP"
                        style={{
                          display: "block",
                          margin: "0 auto 20px",
                          width: "80px"
                        }}
                      />

                      {/* <h5 className="card-title font-bold text-center mb-1 mt-4">
                        {t('couldntSend')}
                      </h5> */}

                      <p>{errorMsg}</p>

                    </div>

                    <button
                      onClick={() => {
                        setOTPSuccess(true);
                        setOTPInvalid(false);
                        setErrorMsg("");
                        setTimerCompleted(false);
                      }}
                      className="btn submitBtn text-center btn-secondary py-2 center-textbtn mt-3 my-2 text-white otpSubmitBtn otpErrorBtn btnshadow"
                      id="submitBtn"
                    >
                      {t('tryagain')}
                    </button>

                  </div>
                )}

              {/* //genuinityCheckModal */}
              <CustomModal
                id={"genuinityCheckModal"}
                title={
                  <>
                    {/* {!scanedDataObject.hasOwnProperty('isSpinDone') && (
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          onClick={handleNavigation}
                        >
                          <img src={Close} alt="Close" />
                        </button>
                      )} */}


                  </>
                }
                content={
                  <>
                    {/* {scanResponseData?.productName} */}
                    {/* <p className="mb-1 modalInfo" style={{ textTransform: 'capitalize' }}>
                        {t("productName")}: {apiProductName}
                      </p> */}
                    {/* <img src={scanResponseData.productImageUrl} alt="GenuityCheck" style={{ width: '100px', marginBottom: '1rem' }} /> */}

                    <div className='d-flex flex-column align-items-center' style={{ gap: '1rem' }}>
                      <img src={Check} alt='check' />

                      {scanResponseData.productImageUrl && (
                        <img src={scanResponseData.productImageUrl} alt="GenuityCheck" style={{ width: '125px' }} />
                      )}

                      {scanResponseData.primaryRewardMsg && (
                        <p className=' text-secondaryColor font-bold mb-0' dangerouslySetInnerHTML={{ __html: scanResponseData?.primaryRewardMsg }}></p>)}


                      {scanResponseData.secondaryRewardMsg && (
                        <p className='mb-0 text-sm' dangerouslySetInnerHTML={{ __html: scanResponseData?.secondaryRewardMsg }}></p>)
                      }

                      {scanResponseData.scanLimitReached && (
                        <p
                          className="genuityCheckLimitMsg text-center mb-0 px-2"
                          dangerouslySetInnerHTML={{
                            __html: scanLimitNotice.replace(/\r\n|\n|\r/g, "<br />"),
                          }}
                        />
                      )}
                    </div>

                    {productID && (<div className="text-left mb-2" style={{ marginTop: "3rem" }}>
                      <p className="mb-1">{t('Product_Serial_Number')}</p>
                      <p className="mb-0" style={{ display: 'block', fontWeight: '600' }}>
                        <img src={ProductId} alt="ProductId" className='img-fluid mr-2' style={{ width: '35px' }} />
                        {productID}</p>
                    </div>
                    )}

                    {/* {scanResponseData.isAlreadyScannedProduct && (
                      <>
                        <p className={`${!productID ? 'mt-10' : ''} mb-2 modalInfo text-danger pt-2`} dangerouslySetInnerHTML={{ __html: scanResponseData?.primaryRewardMsg }}>
                        </p>
                      </>
                    )} */}
                  </>
                }
                footer={
                  <div className="genuityCheckModalFooter w-100">
                    {/* <Button
                      className="w-100 rounded-4 py-2 btn-secondary"
                      onClick={handleGenuityScanMore}
                    >
                      {t("Scanmore")}
                    </Button> */}
                    {!scanResponseData.scanLimitReached && (
                      <Button
                        className="w-100 rounded-4 py-2 btn-secondary btnshadow"
                        onClick={handleGenuityProceedCashback}
                      >
                        {t("genuityCheck.proceedToCashback")}
                      </Button>
                    )}
                  </div>
                }
                show={GenunityCheckModal}
                onHide={() => setGenunityCheckModal(false)}
              />

              {/*///not genuine case */}
              <CustomModal
                id={"genuinityCheckModalError"}
                title={
                  <>
                    {/* <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => {
                          setErrorModalGenunity(false);
                          handleNavigation();
                        }}
                      >
                        <img src={Close} alt="Close" />
                      </button> */}

                    {/* {t("genuityCheck")} */}

                  </>
                }

                content={
                  <>
                    <img src={Wrongotp} alt='Wrongotp' className='img-fluid my-4' />

                    {/* <p className="mb-1 modalInfo">{t("serialNO")}: {scanResponseData.prodSerialNumber}</p> */}
                    {/* {scanErrorResponseData?.productName && (
                      <p className="mb-1 modalInfo">
                        {t("productName")}: {apiProductName}
                      </p>
                    )} */}

                    {/* <img src={apiProductName.toLowerCase().includes("delegate") ? GenuityCheckDelegate : GenuityCheckTracer} alt="GenuityCheck" style={{ width: '100px' }} /> */}
                    {/* <img src={Packet} alt="GenuityCheck" style={{ width: '200px', margin: '1.5rem 0rem 4rem 0rem' }} />
                    <img src={Not_Genuine} alt="Not_Genuine" className="notGenuine_corteva_product" /> */}

                    {/* {scanResponseData?.uq_message && (
                      <p className="mb-0 modalInfo">
                        {scanResponseData?.uq_message}
                      </p>
                    )} */}

                    {scanResponseData.primaryRewardMsg && (
                      <p style={{ fontWeight: '600', color: '#000000', textAlign: 'center' }}>
                        {scanResponseData?.primaryRewardMsg}
                      </p>
                    )}
                    {scanResponseData.secondaryRewardMsg && (
                      <p style={{ fontWeight: '400', color: '#000000', textAlign: 'center' }} >
                        {scanResponseData?.secondaryRewardMsg}
                      </p>
                    )}




                  </>
                }
                footer={
                  <>
                    <div className="d-flex justify-content-between w-100" style={{ gap: '.5rem' }}>
                      {/* <Button
                        className="w-100 rounded-4 py-2 btn-secondary" onClick={() => {
                          navigate(`/${lang}/`)
                        }}>
                        {t("Done")}
                      </Button> */}

                      <Button
                        className="w-100 rounded-4 py-2  btn-primary" onClick={() => {
                          ReactGA.event({
                            category: 'Btn',
                            label: 'User Scan Again',
                            action: 'Clicked the Scan Again Button',
                          });
                          navigate(`/${lang}/scanProduct`)
                        }}>
                        {/* {t("Scanmore")} */}
                        {t('scanAgain')}
                      </Button>
                    </div>

                  </>

                }
                show={ErrorModalGenunity}
                onHide={() => setErrorModalGenunity(false)}
              />

            </div>
          </div>
        </div>



      </div>
    </>
  )
}

export default VerifyOtp
